import React from 'react'
import cx from 'classnames'

import Modal from 'components/shared/Modal'

import './style.styl'

const PlaybookModal = ({
  className,
  children,
  description,
  hideDescription,
  hideTitle,
  title,
  onCancelClick,
  cancelLabel,
  onCloseClick,
  closeLabel = 'Close',
  contentClassName,
  headerClassName,
  ...rest
}) => (
  <Modal onRequestClose={onCloseClick} className={cx('playbook-modal', className)} isOpen {...rest}>
    <header className={cx('flex-space-between', 'playbook-modal-header', headerClassName)}>
      <div>
        {!hideTitle &&
          <span className="playbook-modal-title">
            {title}
            {!hideDescription && ': '}
          </span>
        }
        {!hideDescription && (description || '...')}
      </div>
      <div className="flex">
        {!!onCancelClick &&
          cancelLabel && (
            <button className="playbook-modal-cancel-button" onClick={onCancelClick}>
              {cancelLabel}
            </button>
          )}
        <button className="playbook-modal-close-button" onClick={onCloseClick}>
          {closeLabel}
        </button>
      </div>
    </header>
    <div className="playbook-modal-content">
      <div className={contentClassName}>{children}</div>
    </div>
  </Modal>
)

export default PlaybookModal



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/PlaybookModal/index.js